export default __webpack_public_path__ + "static/media/IBMPlexMono-Regular-Latin2.8af6b3d1.woff2";